import React from "react";
import "../styles/TimeSelect.css";
import { Trans } from "@lingui/react/macro";

const TimeSelect = ({ name, value, handleInputChange }) => {
    const hours = Math.floor(value || 0);
    const minutes = Math.round((value % 1) * 60);

    return (
        <div className="select-container">
            <select
                name={`${name}_hours`}
                value={hours}
                onChange={handleInputChange}
                className="time-select"
            >
                {Array.from({ length: 5 }, (_, i) => (
                    <option key={i} value={i}>
                        {i} <Trans>hours</Trans>
                    </option>
                ))}
            </select>
            <select
                name={`${name}_minutes`}
                value={minutes}
                onChange={handleInputChange}
                className="time-select"
            >
                {Array.from({ length: 12 }, (_, i) => (
                    <option key={i} value={i*5}>
                        {i*5} <Trans>minutes</Trans>
                    </option>
                ))}
            </select>
        </div>
    );
};

export default TimeSelect;
